import React, { PureComponent } from 'react'
import { connect } from 'react-redux'

import containerSelector from 'redux/selectors/matching_pairs/creation_tool_preview_selector'
import MatchingPairsStudentView from 'views/slides/activities/matching_pairs/student/view'

import takeScreenshot from 'helpers/screenshotHandler'

class MatchingPairsScreenshotContainer extends PureComponent {

	onGridLoaded = () => {
		takeScreenshot()
	}

	render() {
		if (this.props.activityData.pairs && this.props.activityData.pairs.length) {
			return (
				<MatchingPairsStudentView
					activityData={this.props.activityData}
					should_animate_cards={false}
					should_expand_header_on_start={true}
					onActivityLoaded={this.onGridLoaded}
				/>
			)
		} else {
			return null
		}
	}
}

function mapStateToProps(state) {
	return containerSelector(state)
}

MatchingPairsScreenshotContainer.defaultProps = {
	activityData: {
		pairs: [],
	},
}

export default connect(mapStateToProps, null)(MatchingPairsScreenshotContainer)
